<template>
    <div>
        <div class="brdr_box_w_checkbox">

            <label class="switch_checkbox_item">
                <input type="checkbox" :checked="appConfig['pp_default']" @change="$emit('update', $event.target.checked, 'pp_default')">
                <div class="switch_checkbox"><span></span></div>
            </label>

            <h3>Select PayPal as the <b>default payment option</b>
	            <info-icon info="PayPal will be the default selected payment option, while still allowing users to select other payment options if available."></info-icon>
            </h3>

        </div>

        <div class="brdr_box_w_checkbox">

            <label class="switch_checkbox_item">
                <input type="checkbox" :checked="appConfig['cf_tracking']" @change="$emit('update', $event.target.checked, 'cf_tracking')">
                <div class="switch_checkbox"><span></span></div>
            </label>

            <h3>Track PayPal orders in <b>Clickfunnels</b>
	            <info-icon>
		            <p><b>Clickfunnels has made it impossible to track orders in both
			            platforms (Funnelish and Clickfunnels) at the same time.</b></p>
		            <div style="margin-top:5px;">Thus, you'll have to select whether to:
		            <ul style="margin-top:5px;list-style: disc inside">
			            <li style="margin-bottom: 5px;">Track your orders in Funnelish and use Funnelish automations on them and have
				            all your funnel analytics in one place.</li>

			            <li>Or, track your orders in Clickfunnels (which isn't recommended unless you have
				            to use an integration through it that is not supported directly yet by Funnelish).</li>
		            </ul>
		            </div>
	            </info-icon>
            </h3>
        </div>

    </div>
</template>

<script>
import Loading from "@/components/Loading.vue"
import Tooltip from "@/components/Tooltip.vue"
import InfoIcon from "@/components/base/info-icon";

export default {
    name: 'PayPal',
    props: ['dataBufferObject'],
    components: {
	    InfoIcon,
        Tooltip
    },
    data() {
        return {
            appConfig: {}
        }
    },
    created(){
        if(this.dataBufferObject) {
            this.appConfig = this.dataBufferObject;
        } else {
            this.appConfig = {"pp_default":false,"cf_tracking":false}
        }
    }
}
</script>
